import { SwipeableDrawer } from './SwipeableDrawer'

export default SwipeableDrawer
